import React from "react";
import { Clock, RefreshCcw, Edit3 } from "lucide-react";
import { formatDiagnosticDate } from "../../../utils/dateFormatter";

function SystemRestartd({ diagnosticData }) {
  const restartStatus = diagnosticData?.restartStatus?.[0];

  const currentTimestamp = formatDiagnosticDate(restartStatus?.CurrentTimestamp);
  const uptimeAtRestart = formatDiagnosticDate(restartStatus?.UptimeAtRestart);
  const systemUpTime = formatDiagnosticDate(restartStatus?.SystemTimestamp);

  return (
    <div className="space-y-4">
      {/* Current Timestamp */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Clock className="text-blue-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">Current Timestamp</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {currentTimestamp}
        </div>
      </div>

      {/* Uptime at Restart */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-green-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <RefreshCcw className="text-green-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">Uptime Before Last Restart</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {uptimeAtRestart}
        </div>
      </div>

      {/* Last System Up Time */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-red-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Edit3 className="text-red-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">Last System Up Time</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {systemUpTime}
        </div>
      </div>
    </div>
  );
}

export default SystemRestartd;

